export function isProductPage(url: string): boolean {
  const pathname = url.split('?')[0] || ''
  const segments = pathname.split('/').filter(Boolean)

  return (
    segments.length === 3
    && segments[0] === 'product-details'
    && Boolean(segments[1])
    && Boolean(segments[2])
  )
}

export function isUnresolvableProductDetailsPath(url: string): boolean {
  const pathname = url.split('?')[0] || ''
  const segments = pathname.split('/').filter(Boolean)

  return segments[0] === 'product-details' && (segments.length === 1 || segments.length > 3)
}
